
  import { defineComponent, inject } from "vue";

  import { get, isEmpty, unset } from "lodash";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import { ContextKeys } from "@/enums/contextKeys.enum";
  import { Events } from "@/enums/events.enum";

  export default defineComponent({
    name: "SimpleSelectV2",

    extends: BaseProcessComponentV2,

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    data() {
      return {
        defaultValue: null as any,
        loading: false as boolean,
        options: [] as any,
      };
    },

    methods: {
      executeClearAction() {
        if (this.$refs[this.ref]) {
          (this.$refs[this.ref] as any).clear();
        }
      },

      formatReadValue(value: any) {
        if (typeof value === "object") {
          const labelKey: string = get(this, "settings.attributes.label", "label") as string;
          return get(value, labelKey, value);
        }

        return value;
      },

      async handleOnChange(value: any) {
        if (this.previousEvent !== Events.CLEAR && !isEmpty(value)) {
          await this.processEvent({
            events: this.resolvedClientSideEvents,
            eventName: `$this.${Events.CHANGE}`,
            context: {
              [ContextKeys.THIS]: this,
              [ContextKeys.FORM]: get(this, this.root, {}),
            },
          });
        }

        this.previousEvent = Events.CHANGE;
      },

      async handleClear() {
        if (this.attributes.name) {
          unset(this, this.path);
        }

        this.previousEvent = Events.CLEAR;

        await this.processEvent({
          events: this.resolvedClientSideEvents,
          eventName: `$this.${Events.CLEAR}`,
          context: {
            [ContextKeys.THIS]: this,
            [ContextKeys.FORM]: get(this, this.root, {}),
          },
        });
      },
    },
  });
